<template>
  <form class="locale-selector">
    <div class="dropdown">
      <button
        class="btn btn-default dropdown-toggle"
        type="button"
        id="dropdownMenu1"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="true"
      >
        <img :src="currLangImage" />
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li>
          <img
            @click="locale = 'fi'"
            src="../../assets/img/fi.png"
            width="100%"
          />
        </li>
        <li>
          <img
            @click="locale = 'en'"
            src="../../assets/img/uk.png"
            width="100%"
          />
        </li>
      </ul>
    </div>
  </form>
</template>
<script>
export default {
  computed: {
    locale: {
      get() {
        return this.$store.state.i18n.locale;
      },
      set(value) {
        this.$store.dispatch("setLocale", value);
      },
    },
    currLangImage: function () {
      if (this.locale == "fi") {
        return require("../../assets/img/fi.png");
      } else if (this.locale == "en") {
        return require("../../assets/img/uk.png");
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped>
.dropdown-toggle {
  padding: 0;
}
select {
  width: 300px;
}
.locale-selector {
  width: 50px;
}
.dropdown-menu {
  width: 37px;
  min-width: 37px;
  padding: 0px;
}
.dropdown {
  padding: 0;
  margin-top: 0;
}
img {
  width: 35px;
  cursor: pointer;
}
.btn {
  color: #fff;
}
@media screen and (max-width: 768px) {
  .locale-selector {
    position: absolute;
    top: 25px;
    right: 120px;
  }
}
</style>
